import {
  FETCH_API_KEYS_REQUEST,
  FETCH_API_KEYS_SUCCESS,
  FETCH_API_KEYS_FAILURE,
  CREATE_API_KEY_REQUEST,
  CREATE_API_KEY_SUCCESS,
  CREATE_API_KEY_FAILURE,
  DELETE_API_KEY_REQUEST,
  DELETE_API_KEY_SUCCESS,
  DELETE_API_KEY_FAILURE,
  RESET_API_KEY_STATE
} from '#action/types';

const initialState = {
  apiKeys: [],
  loading: false,
  error: null,
  creating: false,
  deleting: false
};

export default function apiKeysReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_API_KEYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_API_KEYS_SUCCESS:
      return {
        ...state,
        loading: false,
        apiKeys: action.payload,
        error: null
      };

    case FETCH_API_KEYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case CREATE_API_KEY_REQUEST:
      return {
        ...state,
        creating: true,
        error: null
      };

    case CREATE_API_KEY_SUCCESS:
      return {
        ...state,
        creating: false,
        error: null
      };

    case CREATE_API_KEY_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload
      };

    case DELETE_API_KEY_REQUEST:
      return {
        ...state,
        deleting: true,
        error: null
      };

    case DELETE_API_KEY_SUCCESS:
      return {
        ...state,
        deleting: false,
        apiKeys: state.apiKeys.filter(key => key.id !== action.payload),
        error: null
      };

    case DELETE_API_KEY_FAILURE:
      return {
        ...state,
        deleting: false,
        error: action.payload
      };

    case RESET_API_KEY_STATE:
      return initialState;

    default:
      return state;
  }
}
